function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  id: "Group_6",
  "data-name": "Group 6",
  transform: "translate(-1433.229 -192.529)"
}, /*#__PURE__*/React.createElement("ellipse", {
  id: "path65-3-5-7-0",
  cx: 2.404,
  cy: 2.365,
  rx: 2.404,
  ry: 2.365,
  transform: "matrix(0.707, -0.707, 0.707, 0.707, 1434, 204.957)",
  fill: "none",
  strokeWidth: 1.09
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "path65-3-5-7-9-9",
  cx: 3.683,
  cy: 3.605,
  rx: 3.683,
  ry: 3.605,
  transform: "translate(1439.276 198.509) rotate(-44.999)",
  fill: "none",
  strokeWidth: 1.09
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "path65-3-5-7-0-2",
  cx: 2.404,
  cy: 2.365,
  rx: 2.404,
  ry: 2.365,
  transform: "matrix(0.707, -0.707, 0.707, 0.707, 1441.056, 208.429)",
  fill: "none",
  strokeWidth: 1.09
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "path65-3-5-7-0-8",
  cx: 2.404,
  cy: 2.365,
  rx: 2.404,
  ry: 2.365,
  transform: "matrix(0.707, -0.707, 0.707, 0.707, 1448.256, 204.957)",
  fill: "none",
  strokeWidth: 1.09
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_1",
  "data-name": "Line 1",
  y2: 4.167,
  transform: "translate(1444.427 202.194)",
  fill: "rgba(255,255,0,0)",
  strokeWidth: 1.09
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_2",
  "data-name": "Line 2",
  x1: 3.132,
  y2: 2.737,
  transform: "translate(1438.782 200.973)",
  fill: "rgba(255,255,0,0)",
  strokeWidth: 1.09
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_3",
  "data-name": "Line 3",
  x2: 3.406,
  y2: 2.374,
  transform: "translate(1446.842 201.099)",
  fill: "rgba(255,255,0,0)",
  strokeWidth: 1.09
}));

const SvgGraphForce = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "current",
  stroke: "current",
  width: 22.541,
  height: 20.013,
  viewBox: "0 0 22.541 20.013",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGraphForce, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/graph-force.9dd0f0d9.svg";
export { ForwardRef as ReactComponent };